import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'react-bootstrap';

@observer
class ModalBase extends React.Component {


    render() {
        let {show, onHide, size, backdrop = true, keyboard = true, enforceFocus = true, scrollable = true} = this.props;
        return (
            <Modal
                style={{ zIndex: '99999'}}
                enforceFocus={enforceFocus}
                centered
                show={show}
                onHide={() => onHide && onHide()}
                size={size}
                backdrop={backdrop}
                keyboard={keyboard}
                onEscapeKeyDown={(e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                }}
                scrollable={scrollable}

            >
                {this.props.children}
            </Modal>
        )
    }
}

export default ModalBase;
